import React, { Fragment, PureComponent } from 'react';
import styled from 'styled-components';
import { Text, FlexView, Row, Col } from '@cuemath/comps';

import COLORS from 'constants/colors';

import ExtraSheetBlock from './extra-sheet-block';

const BackgroundWrapper = styled.div`
  margin-top: 80px;
`;

const Wrapper = styled.div`
  margin: 0 auto;
  padding-bottom: 48px;
`;

const BlockTitle = styled(Text)`
  font-size: 20px;
  position: relative;
  top: -2px;
`;

const SectionWrapper = styled(FlexView)`
  margin-top: 12px;
`;

const SectionRect = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 2px;
  background-color: ${COLORS.HEART_LIGHT};
`;

const ExtraSheetHeader = styled(Row)`
  width: 500px;
`;

export class ExtraSheet extends PureComponent {
  constructor(props) {
    super(props);

    this.extraSheetData = React.createRef();
  }

  state = {
    selectedNodeList: [],
    allNodesSelected: false,
  };

  componentDidUpdate() {
    const { extraSheetList } = this.props;
    const { selectedNodeList } = this.state;

    if (!this.extraSheetData.current || this.extraSheetData.current.length === 0) {
      this.extraSheetData.current = extraSheetList;
    } else if (this.extraSheetData.current.length !== extraSheetList.length) {
      this.extraSheetData.current = extraSheetList;

      this.setState({
        selectedNodeList: [],
        allNodesSelected: false,
      });
    } else if (this.extraSheetData.current.length === selectedNodeList.length) {
      this.setState({
        allNodesSelected: true,
      });
    }
  }

  render() {
    const { extraSheetList } = this.props;
    const { selectedNodeList, allNodesSelected } = this.state;

    return (
      <BackgroundWrapper>
        <Wrapper>
          {extraSheetList && extraSheetList.length > 0 && (
            <Fragment>
              <ExtraSheetHeader alignItems="center">
                <Col gutter={18}>
                  <FlexView>
                    <SectionRect />
                  </FlexView>
                </Col>
                <BlockTitle weight="semibold" color={COLORS.ABBEY}>
                  Extra Sheets
                </BlockTitle>
              </ExtraSheetHeader>

              {extraSheetList.map((item, index) => {
                return (
                  <SectionWrapper key={item.id}>
                    <ExtraSheetBlock
                      {...item.worksheet}
                      nodeId={item.id}
                      nodeType={item.node_type}
                      selectedNodeList={selectedNodeList}
                      allNodesSelected={allNodesSelected}
                    />
                  </SectionWrapper>
                );
              })}
            </Fragment>
          )}
        </Wrapper>
      </BackgroundWrapper>
    );
  }
}
